"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputField = function InputField(_ref) {
  var onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      error = _ref.error,
      id = _ref.id,
      type = _ref.type,
      value = _ref.value,
      name = _ref.name;

  var handleChange = function handleChange(e) {
    e.preventDefault();
    if (onChange) {
      onChange(e);
    }
  };

  return _react2.default.createElement("input", {
    onChange: handleChange,
    className: "luna-input",
    placeholder: placeholder,
    "aria-describedby": error ? "inputFeedbackText-" + id : null,
    name: name,
    id: id,
    type: type,
    value: value
  });
};

exports.default = InputField;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Input/InputField.js